import { render, staticRenderFns } from "./DayItemDb.vue?vue&type=template&id=f2c85ba6"
import script from "./DayItemDb.ts?vue&type=script&lang=ts&external"
export * from "./DayItemDb.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports